var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9869 4.0836V4.50027H14.4036H18.012C18.8759 4.50027 19.5794 5.20376 19.5794 6.06767V18.6803H8.80151V17.5124V17.0958H8.38484H4.77641C3.9125 17.0958 3.20901 16.3923 3.20901 15.5284V6.09438V5.67772H2.79234H0.41276V2.43255C0.41276 1.56864 1.11625 0.865153 1.98016 0.865153H12.4195C13.2834 0.865153 13.9869 1.56864 13.9869 2.43255V4.0836ZM2.79234 5.33914H3.20901V4.92247V2.43255C3.20901 1.75458 2.65813 1.20369 1.98016 1.20369C1.30219 1.20369 0.751302 1.75458 0.751302 2.43255V4.92247V5.33914H1.16797H2.79234ZM3.54755 15.5283V15.5373L3.54794 15.5462C3.61765 17.1699 5.94055 17.1412 6.00492 15.5451L6.00526 15.5367V15.5283V6.72013V6.06767C6.00526 5.20376 6.70875 4.50027 7.57266 4.50027H13.2317H13.6484V4.0836V2.43255C13.6484 1.75458 13.0975 1.20369 12.4195 1.20369H3.78965H3.14486L3.40977 1.79155C3.49809 1.98754 3.54755 2.20413 3.54755 2.43255V15.5283ZM6.20606 16.1693L5.94115 16.7572H6.58594H8.38488H8.80155V16.3405V6.06767V6.05894L8.80118 6.05023C8.73346 4.43347 6.40933 4.44759 6.34418 6.05075L6.34384 6.0592V6.06767V6.72013V15.5283C6.34384 15.7568 6.29438 15.9733 6.20606 16.1693ZM9.14005 17.925V18.3417H9.55672H18.4075H18.8242H18.8242L18.8242 17.925H19.2408V6.06767C19.2408 5.38975 18.69 4.83881 18.012 4.83881H9.38277H8.73809L9.00287 5.42661C9.09089 5.62201 9.14005 5.83878 9.14005 6.06767V17.925Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.833333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9362 7.91191H16.4544V8.25045H11.9362V7.91191Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9362 10.2557H16.4544V10.5942H11.9362V10.2557Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.833333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9362 12.5994H16.4544V12.9379H11.9362V12.5994Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.833333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9362 14.9432H16.4544V15.2817H11.9362V14.9432Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningsIcon);
export default __webpack_public_path__ + "static/media/earnings-icon.f60add3fa13574550b217cf031e3a1ea.svg";
export { ForwardRef as ReactComponent };